import { useMemo } from 'react';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

export function usePageStateValue() {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();

	return useMemo(() => {
		const {
			id,
			geoReach,
			createdAt,
			signatureState,
			user,
			tagsConnection,
			decisionMakersConnection,
			relevantLocationLocalizedName,
			score,
		} = petition;
		return {
			petition: {
				id,
				geoReach,
				relevantLocationLocalizedName,
				user,
				createdAt,
				signatureCount: signatureState.signatureCount,
				tags: tagsConnection.nodes,
				decisionMakers: decisionMakersConnection.nodes,
				score,
			},
		};
	}, [petition]);
}
